export const environment = {
  production: true,
  apiUrl: "https://wzn-api.oasisoft.net/api/",
  // apiUrl: "https://api.wazen.com/api/",
  //apiUrl: "https://localhost:44379/api/",
  apiAssetsUrl: "https://wzn-api.oasisoft.net/logo/",
  appUrl: "https://wzn-api.oasisoft.net/",
};
